import { Navigate } from 'react-router-dom'
import { useLocale } from 'src/hooks/use-locale'

export const NavigateToNotFound = () => {
  const { locale } = useLocale()
  return <Navigate to={`/${locale}/not-found`} replace />
}

export default NavigateToNotFound
